import React from 'react'

import Img from './Img'
import MoreButton from './MoreButton'

const QuoteSectionComponent = ({
  quote,
  authorAvatar,
  authorName,
  authorPosition,
  buttonText,
  buttonLink,
  buttonTheme,
  backgroundImage,
}) => {
  return (
    <div className="quote-background-container">
      <q className="q">{quote}</q>
      <div className="details-box">
        <div className="author-box">
          <Img
            image={authorAvatar?.gatsbyImageData}
            alt={authorAvatar?.alt}
            className="author-image"
          />
          <div>
            <p className="author-name">{authorName}</p>
            <p className="p p-14">{authorPosition}</p>
          </div>
        </div>
        {buttonText ? (
          <MoreButton text={buttonText} link={buttonLink} theme={buttonTheme} />
        ) : null}
      </div>
      {backgroundImage ? (
        <Img
          image={backgroundImage.gatsbyImageData}
          alt={backgroundImage.alt}
          className="background-image"
        />
      ) : null}
    </div>
  )
}

export default QuoteSectionComponent
